import { AIHistoryRecord } from '../type';

// Prefer backend communication_type; fallback mirrors format_call_title (company alert calls are inbound).
export const isInboundCall = (
  record: Pick<AIHistoryRecord, 'alert' | 'alert_title' | 'communication_type'>
): boolean => {
  if (record.communication_type)
    return record.communication_type === 'inbound_call';
  return (
    record.alert?.notification_type === 'company_alert' ||
    /inbound call/i.test(record.alert_title ?? '')
  );
};
